var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ol",
    { staticClass: "breadcrumb resultscrumb" },
    _vm._l(_vm.crumbs, function (crumb, index) {
      return _c(
        "li",
        {
          key: index,
          class: {
            active: !(
              crumb.onClick && !_vm.disabled
            ) /* activate state is inverted, i.e. active is noninteractable */,
          },
        },
        [
          crumb.onClick && !_vm.disabled
            ? _c(
                "a",
                {
                  class: _vm.disabled ? "disabled" : undefined,
                  attrs: {
                    role: "button",
                    title: crumb.title,
                    disabled: _vm.disabled,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      !_vm.disabled && crumb.onClick
                        ? crumb.onClick()
                        : undefined
                    },
                  },
                },
                [_vm._v(_vm._s(crumb.label))]
              )
            : [_vm._v(_vm._s(crumb.label))],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }